var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { injectable, inject } from 'inversify';
import { TYPES } from '@/dependency-injection/types';
import * as parse from 'date-fns/parse';
import * as format from 'date-fns/format';
import * as startOfHour from 'date-fns/start_of_hour';
import * as addHours from 'date-fns/add_hours';
import * as addDays from 'date-fns/add_days';
import * as addMinutes from 'date-fns/add_minutes';
import { ApiClient } from '@/services/base-axios-client';
import { AuthService } from '@/services/auth-service';
var VacationService = /** @class */ (function (_super) {
    __extends(VacationService, _super);
    function VacationService(authService) {
        var _this = _super.call(this, '/api/v1/management') || this;
        _this.authService = authService;
        return _this;
    }
    /**
     * Get all vacations
     */
    VacationService.prototype.all = function (includeDeleted) {
        if (includeDeleted === void 0) { includeDeleted = true; }
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/vacation/getall';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {})];
                    case 2:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Unable to get vacations");
                        console.error(error_1);
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Delete a vacation
     * @param vacation Vacation to delete
     */
    VacationService.prototype.delete = function (vacation) {
        return __awaiter(this, void 0, Promise, function () {
            var data, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        data = __assign({}, vacation);
                        // only planned vacations can be deleted
                        if (this.canDeleteVacation(data) === false) {
                            return [2 /*return*/, {
                                    success: false,
                                    message: 'Only planned vacations can be deleted',
                                }];
                        }
                        // set to deleted
                        data.status = 'I';
                        return [4 /*yield*/, this.save(data)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_2 = _a.sent();
                        console.error('Unable to delete vacation');
                        console.error(error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Restore a vacation
     * @param vacation Vacation to restore
     */
    VacationService.prototype.restore = function (vacation) {
        return __awaiter(this, void 0, Promise, function () {
            var data, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        data = __assign({}, vacation);
                        // only inactive vacations can be restored
                        if (this.canRestoreVacation(data) === false) {
                            return [2 /*return*/, {
                                    success: false,
                                    message: 'Only inactive vacations can be restored',
                                }];
                        }
                        // set to planned
                        data.status = 'P';
                        return [4 /*yield*/, this.save(data)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_3 = _a.sent();
                        console.error('Unable to restore vacation');
                        console.error(error_3);
                        throw error_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * End a vacation
     * @param vacation Vacation to end early
     */
    VacationService.prototype.end = function (vacation) {
        return __awaiter(this, void 0, Promise, function () {
            var data, endOfNextHour, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        data = __assign({}, vacation);
                        // only active vacations can be ended
                        if (this.canEndVacation(vacation) === false) {
                            return [2 /*return*/, {
                                    success: false,
                                    message: 'Only active vacations can be ended',
                                }];
                        }
                        endOfNextHour = addHours(startOfHour(new Date()), 1);
                        data.toDate = format(endOfNextHour, 'YYYY-MM-DD');
                        data.toTime = format(endOfNextHour, 'HH:mm');
                        return [4 /*yield*/, this.save(data)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_4 = _a.sent();
                        console.error('Unable to end vacation');
                        console.error(error_4);
                        throw error_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Save vacation
     * @param vacation the vacation to save
     */
    VacationService.prototype.save = function (vacation) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, data, oneMinuteAgo, fromDate, toDate, formattedFromDate, formattedToDate, response, responseMessage, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        endpoint = '/vacation/save';
                        data = __assign({}, vacation);
                        if (this.canEditVacation(data) === false) {
                            return [2 /*return*/, {
                                    success: false,
                                    message: 'Unable to save user',
                                }];
                        }
                        // update from date it set to 'NOW'
                        if (data.fromTime === 'NOW') {
                            // only planned vacations can be started immediately
                            if (this.canStartVacation(data) === false) {
                                return [2 /*return*/, {
                                        success: false,
                                        message: 'Only planned vacations can be started immediately',
                                    }];
                            }
                            oneMinuteAgo = addMinutes(new Date(), -1);
                            data.fromTime = format(oneMinuteAgo, 'HH:mm');
                        }
                        fromDate = parse(data.fromDate + "T" + data.fromTime);
                        toDate = parse(data.toDate + "T" + data.toTime);
                        formattedFromDate = format(fromDate, 'YYYY-MM-DDTHH:mm:ss');
                        formattedToDate = format(toDate, 'YYYY-MM-DDTHH:mm:ss');
                        // set to pending if no status set
                        data.status = data.status === '' ? 'P' : data.status;
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                VacationID: data.vacationID,
                                UserID: data.userID,
                                BackupType: data.backupType,
                                StartDate: formattedFromDate,
                                EndDate: formattedToDate,
                                Status: data.status,
                            })];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            responseMessage = response.data;
                            if (responseMessage.success === false) {
                                return [2 /*return*/, {
                                        success: false,
                                        message: responseMessage.message,
                                    }];
                            }
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            console.error(response);
                            throw new Error('Unable to save vacation');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_5 = _a.sent();
                        console.error('Unable to save vacation');
                        console.error(error_5);
                        throw error_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get vacation users
     */
    VacationService.prototype.getVacationUsers = function () {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/vacation/getvacationusers';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {})];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data.map(function (user) { return user.userId; })];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_6 = _a.sent();
                        console.error("Unable to get vacation users");
                        console.error(error_6);
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VacationService.prototype.getDefault = function () {
        return {
            vacationID: '',
            userID: '',
            fromDate: format(addDays(new Date(), 1), 'YYYY-MM-DD'),
            fromTime: '00:00',
            toDate: format(addDays(new Date(), 2), 'YYYY-MM-DD'),
            toTime: '00:00',
            backupType: '',
            status: '',
            notes: '',
            modifiedByUserID: '',
            modifiedDate: '',
        };
    };
    /**
     * Get the validation rules to apply
     */
    VacationService.prototype.getValidationRules = function () {
        return {
            userID: {
                required: true,
            },
            fromDate: {
                required: true,
            },
            toDate: {
                required: true,
            },
            backupType: {
                required: true,
            },
        };
    };
    /**
     * Get the hours dropdowns
     * todo: move to reference data
     */
    VacationService.prototype.getHours = function () {
        return [
            '00:00',
            '01:00',
            '02:00',
            '03:00',
            '04:00',
            '05:00',
            '06:00',
            '07:00',
            '08:00',
            '09:00',
            '10:00',
            '11:00',
            '12:00',
            '13:00',
            '14:00',
            '15:00',
            '16:00',
            '17:00',
            '18:00',
            '19:00',
            '20:00',
            '21:00',
            '22:00',
            '23:00',
        ];
    };
    VacationService.prototype.getStatuses = function () {
        return [
            { key: 'A', value: 'Active' },
            { key: 'P', value: 'Planned' },
            { key: 'C', value: 'Completed' },
            { key: 'I', value: 'Deleted' },
        ];
    };
    VacationService.prototype.canEditVacation = function (vacation) {
        // completed vacations can not be updated
        return vacation.status !== 'C';
    };
    VacationService.prototype.canStartVacation = function (vacation) {
        // only planned vacations can be started immediately
        return vacation.status === '' || vacation.status === 'P';
    };
    VacationService.prototype.canEndVacation = function (vacation) {
        // only active vacations can be ended
        return vacation.status === 'A';
    };
    VacationService.prototype.canDeleteVacation = function (vacation) {
        // only planned vacations can be deleted
        return vacation.status === 'P';
    };
    VacationService.prototype.canRestoreVacation = function (vacation) {
        // only inactive vacations can be restored
        return vacation.status === 'I';
    };
    Object.defineProperty(VacationService.prototype, "canEditVacations", {
        get: function () {
            return this.authService.isAuthorized('VACATIONMGMT', 'WRITE');
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    VacationService = __decorate([
        injectable(),
        __param(0, inject(TYPES.AuthService)),
        __metadata("design:paramtypes", [typeof (_a = typeof AuthService !== "undefined" && AuthService) === "function" ? _a : Object])
    ], VacationService);
    return VacationService;
}(ApiClient));
export { VacationService };
